import { TypedRootState } from '../types';

export const selectBilletCutParams = (state: TypedRootState) => state.billetCutParams;
export const selectShapeBilletCutParam = (state: TypedRootState): string => state.billetCutParams.shape;
export const selectSizeXBilletCutParam = (state: TypedRootState): number => state.billetCutParams.sizeX;
export const selectSizeYBilletCutParam = (state: TypedRootState): number => state.billetCutParams.sizeY;
